<div class="modal-wrapper">
  <div class="modal-header">
    <i
      class="fas fa-times clickable"
      (click)="activeModal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body" *ngIf="!multipleInsideSurveysAvailble">
    <div class="modal-nav">
      <div class="modal-nav-item">
        <div
          class="modal-nav-icon pointer"
          (click)="openAddToExistingBuildingGroupModal()"
        >
          <img
            src="assets/Keen&Wise_add to existing BG_small_blue_transparant.png"
            alt="Add building to group"
          />
        </div>
      </div>
      <div class="modal-nav-item">
        <div class="modal-nav-icon">
          <img
            src="assets/Keen&Wise_add to new BG_small_blue_transparant.png"
            alt="Add building group"
          />
        </div>
      </div>
    </div>
    <p i18n i18n="@@buildinggroup.addbuilding.addbuildingtonewgroup">
      Add selected buildings<br />to <strong>new building group</strong>
    </p>
    <div class="row">
      <div class="col-md-6">
        <div class="list-title" i18n="@@buildinggroup.addbuilding.buildings">
          Buildings
        </div>
        <ul class="list">
          <li class="list-item" *ngFor="let building of buildings">
            {{ building.street }} {{ building.number }} {{ building.suffix }}
          </li>
        </ul>
      </div>
      <div class="col-md-6">
        <div
          class="list-title"
          i18n="@@buildinggroup.addbuilding.newbuildinggroup"
        >
          New Building Group
        </div>
        <ul class="list hover">
          <li class="list-item">
            {{ buildingGroupName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="modal-body" *ngIf="multipleInsideSurveysAvailble">
    <div class="modal-nav">
      <div class="modal-nav-item">
        <div
          class="modal-nav-icon pointer"
          (click)="returnToNewBuildingGroupOverview()"
        >
          <img
            src="assets/Keen&Wise_add to existing BG_small_blue_transparant.png"
            alt="Add building to group"
          />
        </div>
      </div>
      <div class="modal-nav-item">
        <div class="modal-nav-icon">
          <img
            src="assets/Keen&Wise_add to new BG_small_blue_transparant.png"
            alt="Add building group"
          />
        </div>
      </div>
    </div>
    <p i18n i18n="@@buildinggroup.addbuilding.selectexistingsurvey">
      Multiple Buildings already have an Inside Survey,<br />
      Select the one <strong>you want to keep.</strong>
    </p>
    <div>
      <div class="list-title" i18n="@@buildinggroup.addbuilding.building">
        Buildings
      </div>
      <ul class="list hover">
        <li
          class="list-item"
          *ngFor="let building of buildingsWithInsideSurvey"
          [ngClass]="{
            selected: selectedBuildingId === building.buildingId
          }"
          (click)="onSelectedBuilding(building.buildingId)"
        >
          {{ building.getShortAddress() }}
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <img
      class="save-btn float-right"
      src="assets/Keen&amp;Wise_save.png"
      (click)="onSave()"
    />
  </div>
</div>
